<template>
    <main class="image-popup-container">
        <el-dialog :visible.sync="visiable" @closed="$emit('closed')">
            <div class="menus-img-container">
                <div class="buttons">
                    <!-- <el-button class="calla" type="success" size="small" @click="jump(1)">{{ $t("message.buttons.whatsApp") }}</el-button> -->
                    <el-button class="calla" type="success" size="small" @click="jump(0)">{{ $t("message.buttons.linkButton") }}</el-button>
                </div>
                <div class="menus-img">
                    <el-image :src="data.menuImage ? `https://order.cateraway.com/api/file/image/${data.menuImage}` : $defaultImg" width="60%" height="100%" :preview-src-list="images" fit="contain"></el-image>
                </div>
                <div class="buttons">
                    <!-- <el-button class="calla" type="success" size="small" @click="jump(1)">{{ $t("message.buttons.whatsApp") }}</el-button> -->
                    <el-button class="calla" type="success" size="small" @click="jump(0)"> {{ $t("message.buttons.linkButton") }}</el-button>
                </div>
            </div>
        </el-dialog>
    </main>
</template>

<script>
import merchantApi from '../../../../api/merchant';
export default {
    props:{
        data:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    computed:{
        images(){
            return [`https://order.cateraway.com/api/file/image/${this.data.menuImage}`]
        }
    },
    data() {
        return {
            visiable:true,
            merchant:{}
        }
    },
    mounted(){
        this.getMerchant()
    },
    methods:{
        jump(value) {
            let link = `https://${this.merchant.url}/product?id=${this.data.id}`
            if (value) {
                let result = this.merchant.contactMethods
                if (result) {
                    let whatsApp = result.find(item => item.contactType == "WHATAPP")
                    let phone = result.find(item => item.contactType == "MOBILE")
                    link = `https://api.whatsapp.com/send?phone=${whatsApp ? whatsApp.content : phone ? phone.content : ''}&text= hello 到會家,我想訂到會！😋😋`
                }
            }
            window.open(link, "_blank");
        },
        getMerchant(){
            merchantApi.getInfo('0da8d60a138edba7918a6517ccd49c9c').then(result => {
                this.merchant = result.data
            })
        }
    }
}
</script>
<style lang="less" scoped>
.image-popup-container {
    ::v-deep .el-dialog{
        margin-top: 10vh !important;
        width: 40%;
        & .el-dialog__header {
            display: none;
        }
        & .el-dialog__body {
            padding: 10px 10px;
        }
        @media (max-width: 1255px) {
            width: 85%;
        }
        @media (max-width: 768px) {
            width: 90%;
        }
        @media (max-width: 480px) {
            width: 100%;
        }
    }
    .menus-img-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        & .menus-img {
            display: flex;
            justify-content: center;
            max-height: 800px;
        }
        & .buttons {
            display: flex;
            justify-content: center;
            align-items: center;
            /* margin-top: 4%; */
            margin: 2% 0;
            & .el-button {
                background-color: #eb6410;
                border-color: #eb6410;
                margin: 0 3%;
                flex: 0 0 47%;
            }
        }
    }
}
</style>